const angular = require('angular');

module.exports = function ($rootScope, $state, $location, settingsService, shopperService, loginService, pageMetadataService, shoppageStateService, cardSizeService, trolleyService, stackchatService) {

    let isStackChatInitilised = false;

    function promptForLogin(event, toState, toParams, fromState) {
        event.preventDefault();
        loginService.promptForLogin(loginService.LoginToContinueMessage, toState, toParams, fromState.name === '');
    }

    // function promptForSecureAccount(event) {
    //     event.preventDefault();
    //     $state.go('shop.secureaccount.form');
    // }

    settingsService.updateSettings();

    $rootScope.$on('$locationChangeStart', function () {
        if ($location.hash().toLowerCase() === 'bodyonly') {
            setTimeout(function () {
                $('#header-container, div[ui-view="toolbar"], footer[class="footer-wrapper"], wow-store-locator-search, feature-promo, bwsbot, wow-toolbar, wow-store-picker-panel, wow-content-overlay').attr('style', 'display:none');
                $('#center-panel').attr('style', 'padding-top:0');
            }, 500);

        } else {
            $('#header-container, div[ui-view="toolbar"], #center-panel, footer[class="footer-wrapper"], wow-store-locator-search, feature-promo, bwsbot, wow-toolbar, wow-store-picker-panel, wow-content-overlay').removeAttr('style');
        }
        if ($location.path().indexOf('/checkout') > -1) {
            shoppageStateService.hideStackChat();
        } else {
            shoppageStateService.showStackChat();
        }

        if (!isStackChatInitilised && $location.hash().toLowerCase() === 'showstackchat') {
            stackchatService.initialise();
            isStackChatInitilised = true;
        }
    });

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        if (toState.data && toState.data.authenticate && shopperService.currentUser.isGuest) {
            if (angular.isArray(toState.data.authenticate)) {
                $state.shouldAuthenticate(toState, toParams).then(function (requiresLogin) {
                    if (requiresLogin) {
                        promptForLogin(event, toState, toParams, fromState);
                    }
                });
            } else {
                promptForLogin(event, toState, toParams, fromState);
            }
        }

        // TODO: uncomment to enable mandatory update password flow for customers with weak password
        // PLEASE NOTE: double check with Trader BE, ensure ShouldUpdatePassword is returned as part of shopper API response
        // if (toState.data && !toState.data.isSecurePasswordFlow && !shopperService.currentUser.isGuest && shopperService.ShouldUpdatePassword) {
        //     promptForSecureAccount(event);
        // }
    });

    $rootScope.$on('$stateChangeSuccess', function () {
        pageMetadataService.useCurrentStateMetadata();
        shoppageStateService.triggerPanel('left', false);
    });

    cardSizeService.initialise();
    trolleyService.initialise();

    $rootScope.$on('ajaxNavigationError', function () {
        $state.go('shop.404error');
    });
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/configuration/startup/index.js
 **/